import { type MouseEvent as ReactMouseEvent, useCallback, useMemo } from 'react';

import { useCardContext } from '@/microfrontends/listing/shared/context/CardContext';
import { cardOfferPublisherSelector } from '@/microfrontends/listing/shared/context/selectors/cardData';
import { useCAForCard } from '@/microfrontends/listing/shared/hooks/useCAForCard';
import { formatPhone } from '@/microfrontends/listing/shared/utils/formatPhone';

import { memoWithDisplayName } from '@/packages/utils';

import { PhoneButton } from './internal/components/PhoneButton/PhoneButton';
import { type DisplayPhonesOptions } from './types';

type HandleClick = (event: ReactMouseEvent<HTMLElement>) => void;

type PhoneButtonContainerProps = {
  displayPhonesOptions?: DisplayPhonesOptions;
};

export const PhoneButtonContainer = memoWithDisplayName<PhoneButtonContainerProps>(props => {
  const cardData = useCardContext();

  const { phones, workHours } = cardOfferPublisherSelector(cardData);
  const displayPhonesOptions = useMemo<DisplayPhonesOptions>(() => {
    return (
      props.displayPhonesOptions || {
        countToDisplay: phones.length,
        shouldDisplayWorkHours: true,
      }
    );
  }, [props.displayPhonesOptions, phones]);

  const caForCard = useCAForCard();

  const handleClick = useCallback<HandleClick>(() => {
    caForCard({ action: 'Open_listing_agent_block', category: 'Phones' }, { label: true });
  }, [caForCard]);

  const prettyPhones = phones.map(formatPhone);
  const prettyWorkHours = workHours ? `Работает с ${workHours.workFrom} до ${workHours.workTo}` : null;

  return (
    <PhoneButton
      displayPhonesOptions={displayPhonesOptions}
      phones={prettyPhones}
      workHours={prettyWorkHours}
      onPhonesShow={handleClick}
    />
  );
}, 'PhoneButtonContainer');
